import React from 'react';
import PropTypes from 'prop-types';
import injectSheet, { withTheme } from 'react-jss';
import { observer } from 'mobx-react';
import BigIcon from './../BigIcon';
import Text from './../Text';
import Switch from './../switch/Switch';

const propTypes = {
    tableType: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    toggleOn: PropTypes.bool,
    toggleFunc: PropTypes.func,
    tableCollapsed: PropTypes.bool,
};

const TableHead = observer(({classes, theme, tableType, tableMetadata, onClick, toggleFunc, toggleOn, tableCollapsed}) => {
    const onChange = (e) => {
        toggleFunc();
    };
    const _onClick = (e) => {
        if (e.target.type === 'checkbox') {
            return;
        }
        onClick();
    };
    return (
        <div className={classes.header} onClick={_onClick}>
            <BigIcon color='yellow'
                     iconColor={tableMetadata.colorPrimary}
                     type={tableType}
                     icon={tableMetadata.icon}/>
            {toggleFunc && !tableCollapsed && <Switch onChange={onChange} toggleOn={toggleOn} color="primary"/>}
            <Text type="tableHeader" classList={classes.headerTitle}>{tableMetadata.title}</Text>
        </div>
    );
});

const styles = theme => ( {
    overrideImg: {
        backgroundColor: props => theme.channelItems.tables[props.tableType]
    },
    header: {
        display: 'flex',
        borderBottom: `1px ${theme.palette.border} solid`,
        position: 'relative'
    },
    headerTitle: {
        ...theme.typography.h3,
        flex: 1,
        margin: 0,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
} );

TableHead.propTypes = propTypes;

export default injectSheet(styles)(withTheme(TableHead));



// WEBPACK FOOTER //
// ./src/app/components/table/TableHeader.js